import { Typography } from "@cpj-ai/panel-npm-package";
import { ElementType } from "react";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import { ICertifiedDocument } from "..";
import CertifiedDocumentCard from "./CertifiedDocumentCard";

export interface ICertifiedDocumentsSliderProps {
  title: string;
  icon: ElementType;
  certifiedDocuments?: ICertifiedDocument[];
  sliderBreakpoints?: {
    [key: number]: {
      slidesPerView: number;
    };
  };
}

const CertifiedDocumentsSlider: React.FC<ICertifiedDocumentsSliderProps> = (props) => {
  return (
    <div>
      <div className="flex items-center gap-1">
        <props.icon width={32} height={32} />
        <Typography className="font-medium">{props.title} : </Typography>
      </div>
      <Swiper spaceBetween={8} className="mt-3" breakpoints={props.sliderBreakpoints}>
        {props.certifiedDocuments?.length ? (
          props.certifiedDocuments?.map((item) => (
            <SwiperSlide key={item.title}>
              <CertifiedDocumentCard {...item} />
            </SwiperSlide>
          ))
        ) : (
          <p className="ms-5">Not set</p>
        )}
      </Swiper>
    </div>
  );
};

export default CertifiedDocumentsSlider;
